// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3OzSv","dragIcon":"Choice_dragIcon__1Ry0R","left":"Choice_left__np6Ow","input":"Choice_input__3XPll"};